import iHeroBottom from "../../../assets/icons/about-us-page/hero-bottom.png";
import iHeroBottomBgRight from "../../../assets/icons/about-us-page/hero-bottom-bg-right.png";
import iHeroBottomBgLeft from "../../../assets/icons/about-us-page/hero-bottom-bg-left.png";
import { useWidth } from "../../../hooks/use-width";
import "./hero-bottom.sass";

const AboutUsHeroBottomBlock = () => {
  const { isMobileWidth, isDesktopWidth } = useWidth();

  return (
    <div className="about-us-hero-bottom">
      <div className="about-us-hero-bottom__title">
        Мыслим стратегически, действуем тактически
      </div>

      {isDesktopWidth && (
        <div className="about-us-hero-bottom__text">
          Берём на себя весь процесс:
          <br />
          от создания смыслов до «как реализовать это в задуманном виде на
          высоте 1600 метров на Красной Поляне».
          <br />И да — любим, когда за креативом стоят цифры.
        </div>
      )}
      {isMobileWidth && (
        <div className="about-us-hero-bottom__text">
          Берём на себя весь процесс:
          <br />
          от идеи до «на чём привести 1000 кг
          <br /> яблок в другой город». И да — любим,
          <br /> когда за креативом стоят цифры.
        </div>
      )}

      <div className="about-us-hero-bottom__hero">
        <img
          src={iHeroBottom}
          className="about-us-hero-bottom__hero-img"
          alt=""
        />
      </div>

      <img
        src={iHeroBottomBgLeft}
        className="img-absolute about-us-hero-bottom__bg-left"
        alt=""
      />

      <img
        src={iHeroBottomBgRight}
        className="img-absolute about-us-hero-bottom__bg-right"
        alt=""
      />
    </div>
  );
};

export default AboutUsHeroBottomBlock;
